import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'react-bootstrap/Card';

export const Unauthorized = () => {
    return (
        <div className="main-content-wrapper">
            <Card className="shadow-sm" style={{width: "400px"}}>
                <Card.Header className="text-center">
                    <FontAwesomeIcon className='fg-blue' size="3x" icon={faShieldHalved} />
                </Card.Header>
                <Card.Body className="p-4">
                    <Card.Title className="text-center"><h2>Unauthorized</h2></Card.Title>
                    <Card.Text style={{ fontSize: "20px" }}>
                        You are not authorized to access this content
                    </Card.Text>
                </Card.Body>
            </Card>
            {/* <div className=" text-center">
                <FontAwesomeIcon className='fg-blue' icon={faShieldHalved} />
                <h2>You are not authorized to access this content</h2>
            </div> */}
        </div>
    )
}